export default __webpack_public_path__ + "static/media/trophy_blue_gradient.5f1fe5b3.svg";